// dropdown.service.ts
import StockService from "@/services/api/stocks/stocks";
import PurchaseOrderService from "@/services/api/purchaseOrder/purschaseOrder";

const DISTRIBUTOR_ID = localStorage.getItem('distributorId')? Number(localStorage.getItem('distributorId')):undefined;

export const DropdownService = {
  async products(search?: string) {
    const res = await PurchaseOrderService.getProductList({
      distributorId: DISTRIBUTOR_ID,
      search,
    });

    const data = Array.isArray(res.data) ? res?.data : [];

    return {
      options: data.map((item: any) => ({
        value: item.productId,
        label: item.productName,
      })),
      raw: data,
    };
  },


  async warehouses(search?: string) {
    const res = await StockService.getWarehouseList({distributorId: DISTRIBUTOR_ID,
      ...search
    }, // search,
    );
    const items = res?.data?.items ?? [];

    return {
      options: items.map((w: any) => ({
        value: w.id,
        label: w.name,
      })),
      raw: items,
    };
  },

  async productsMaster(search?: string) {
    const res = await PurchaseOrderService.getProductMasterList({
      distributorId: DISTRIBUTOR_ID,
      search,
    });

    const data = res?.data ?? [];
  

    return {
      options: data.map((item: any) => ({
        value: item.productId,
        label: item.productName,
        availableQty : item.availableQty
      })),
      raw: data,
    };
  },
};
